import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function Blog() {
  const { t, pick } = useLang();
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page" className="pt-24 md:pt-28 pb-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">{t.home.stories_overline}</p>
        <h1 className="font-serif-display text-4xl md:text-6xl tracking-tight font-light text-charcoal leading-[1.05]">
          {t.blog_page.title}
        </h1>
        <p className="mt-5 max-w-xl text-charcoal-400">{t.blog_page.sub}</p>

        <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14">
          {posts.map((p) => (
            <Link to={`/stories/${p.slug}`} key={p.id} data-testid={`blog-post-${p.slug}`} className="group hover-zoom">
              <div className="aspect-[16/10] overflow-hidden bg-sand-200">
                <img src={imgUrl(p.cover_image)} alt={pick(p.title_en, p.title_fr)} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <h2 className="font-serif-display text-2xl md:text-3xl text-charcoal mt-5 leading-[1.2] group-hover:text-terracotta transition">
                {pick(p.title_en, p.title_fr)}
              </h2>
              <p className="mt-3 text-charcoal-400">{pick(p.excerpt_en, p.excerpt_fr)}</p>
              <p className="mt-4 text-sm text-terracotta underline underline-offset-4">{t.blog_page.read} →</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
